module.exports = __webpack_public_path__ + "img/jiangsuyh.41427b10.png";